// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3lGTx","inner":"Footer_inner__3yaZn"};